import { render, staticRenderFns } from "./transmittals-home.vue?vue&type=template&id=498e482f"
import script from "./transmittals-home.vue?vue&type=script&lang=js"
export * from "./transmittals-home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports